import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  userMenu: {
    padding: 0,
    listStyleType: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: 8
  },
  userMenuLink: {
    textDecoration: 'none'
  },
  userMenuButton: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 12
  }
})

export default useStyles
